import { isMatch } from "../pattern/isMatch";
import { Pattern } from "../pattern/pattern";
import { PhonemeInfo } from "../pattern/phonemeInfo";
import { ipaToFeatures, IpaType } from "../phonemes/ipa";
import { StressRule } from "./stressRule";

/** figure out which syllable to stress (from 1), positive counts from start, negative counts from end */
export function findStressSyllable(word: IpaType[], rule: StressRule<PhonemeInfo>): number {
  if (rule.toCheck !== undefined) {
    for (const toCheck of rule.toCheck) {
      if (hasMatch(toCheck.pattern, word)) {
        return toCheck.which;
      }
    }
  }
  if (!canStress(word)) {
    return 0;
  }
  return rule.default;
}

function hasMatch(pattern: Pattern<PhonemeInfo>, word: IpaType[]): boolean {
  const len = word.length;
  for (let i = 0; i < len; i++) {
    if (isMatch(pattern, word, i) !== false) {
      return true;
    }
  }
  return false;
}

/** check if word can have stress, if it has vowels or consonants */
function canStress(word: IpaType[]): boolean {
  for (const p of word) {
    const features = ipaToFeatures(p);
    if (features?.includes('vowel') || features?.includes('consonant')) {
      return true;
    }
  }
  return false;
}
